import { sendToPrinter } from './eposClient';
import { sendRawToPrinter } from './escposClient';

// The one place that knows how a payload reaches a printer.
//
// The backend returns whichever encoding the printer understands: ePOS
// printers get `xml` to POST over HTTP, ESC/POS printers (e.g. the Epson
// TM-T20X, which exposes no ePOS service at all) get `data_base64` to write
// to a socket on port 9100. Both transports resolve to the same
// {success, reason} shape, so every caller stays identical.
//
// Deliberately its own module rather than living in PrintingUtils: the
// printer settings screen needs this and nothing else from there, and
// importing PrintingUtils would drag react-to-print, date-fns and the whole
// receipt-rendering chain into a settings sheet.
export async function sendPayload(payload) {
    // Defaults to the ePOS path when `protocol` is absent, so a response
    // from a backend that predates this field behaves exactly as before.
    if (payload && payload.protocol === 'escpos') {
        return sendRawToPrinter(payload.ip_address, payload.port, payload.data_base64);
    }
    return sendToPrinter(payload.ip_address, payload.port, payload.xml);
}
